import { render, staticRenderFns } from "./manufacturer-add.vue?vue&type=template&id=44ea941f&"
import script from "./manufacturer-add.vue?vue&type=script&lang=js&"
export * from "./manufacturer-add.vue?vue&type=script&lang=js&"
import style0 from "./manufacturer-add.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44ea941f')) {
      api.createRecord('44ea941f', component.options)
    } else {
      api.reload('44ea941f', component.options)
    }
    module.hot.accept("./manufacturer-add.vue?vue&type=template&id=44ea941f&", function () {
      api.rerender('44ea941f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/data-dictionary/manufacturer/manufacturer-add.vue"
export default component.exports